import styled from 'styled-components'

export default styled.a`
  color: #ce7019;
  cursor: pointer !important;
  font-size: 80%;
  text-align: right;
`
